"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ENV = {
    // 开发环境（本地）
    development: function () {
        return /localhost/g.test(location.hostname);
    },
    // 测试环境（SIT）
    alpha: function () {
        return /sit/g.test(location.hostname);
    },
    // 生产环境
    production: function () {
        return /^(ucmp|ucmp-static|ucmp-x|cx-mgr|ump|hub|mp|mpp|www|wwwgray)\.sf-express\.com$/g.test(location.hostname);
    },
    // 移动终端浏览器版本信息
    versions: function () {
        var u = window.navigator.userAgent;
        return {
            trident: u.indexOf('Trident') > -1,
            presto: u.indexOf('Presto') > -1,
            webKit: u.indexOf('AppleWebKit') > -1,
            gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') === -1,
            mobile: !!u.match(/AppleWebKit.*Mobile.*/) || !!u.match(/AppleWebKit/),
            ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
            android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1,
            iPhone: u.indexOf('iPhone') > -1 || u.indexOf('Mac') > -1,
            iPad: u.indexOf('iPad') > -1,
            webApp: u.indexOf('Safari') === -1,
            aliPay: u.indexOf('AlipayClient') > -1 // 是否为支付宝
        };
    },
    // 获取浏览器名称
    getBrowser: function () {
        var UserAgent = window.navigator.userAgent.toLocaleLowerCase();
        var browserName = 'OtherBrowser';
        var browserMap = {
            WeixinBrowser: function () { return UserAgent.indexOf('micromessenger') > -1; },
            AlipayBrowser: function () { return UserAgent.indexOf('alipay') > -1; },
            UCBrowser: function () { return UserAgent.indexOf('UCBrowser') > -1; },
            QQBrowser: function () { return UserAgent.indexOf('qqbrowser') > -1; },
            Safari: function () { return UserAgent.indexOf('safari') > -1 && UserAgent.indexOf('chrome') === -1; },
            Chrome: function () { return UserAgent.indexOf('chrome') > -1 && UserAgent.indexOf('safari') > -1; },
            IE: function () { return window.ActiveXObject || 'ActiveXObject' in window; },
            Firefox: function () { return UserAgent.indexOf('firefox') > -1; },
            Opera: function () { return UserAgent.indexOf('opera') > -1; },
            Edge: function () { return UserAgent.indexOf('edge') > -1; } // Edge浏览器
        };
        Object.keys(browserMap).some(function (key) {
            if (browserMap[key]()) {
                browserName = key;
                return true;
            }
            return false;
        });
        return browserName;
    },
    // 判断是否微信浏览器
    isWeiXin: function () {
        var ua = window.navigator.userAgent.toLowerCase();
        var a = ua.match(/MicroMessenger/i);
        if (a) {
            return a[0] === 'micromessenger';
        }
        return false;
    },
    // 判断是否支付宝浏览器
    isALiPay: function () {
        var ua = window.navigator.userAgent.toLowerCase();
        var a = ua.match(/Alipay/i);
        if (a) {
            return a[0] === 'alipay';
        }
        return false;
    }
};
exports.default = {
    name: 'utils-check-env',
    install: function (UIP) {
        UIP.checkModule('utils', 'check', 'ENV');
        UIP.utils.check.ENV = ENV;
    }
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@uip-alpha/utils-check-env/dist/index.js
// module id = GvNx
// module chunks = 1